import { render, staticRenderFns } from "./customer_recovery.vue?vue&type=template&id=53e90342&scoped=true&"
import script from "./customer_recovery.vue?vue&type=script&lang=js&"
export * from "./customer_recovery.vue?vue&type=script&lang=js&"
import style0 from "./customer_recovery.vue?vue&type=style&index=0&id=53e90342&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e90342",
  null
  
)

export default component.exports